import React from 'react'

export default function CulturalActivities() {
    return (
        <div>CulturalActivities</div>
    )
}
